"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// import styled from 'styled-components'
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var nanoid_1 = require("nanoid");
var styles_1 = require("../../utils/styles");
var values_1 = require("../../utils/values");
var index_1 = require("../index");
var conditions_1 = require("../../utils/conditions");
/**
 * This component can be used to map General product's data to components
 * based on schema structure
 */
var ProductData = function (_a) {
    var currentComponentSchema = _a.currentComponentSchema, mediaKeys = _a.mediaKeys, templateChildren = _a.templateChildren, styles = _a.styles, items = _a.items, additionalProps = _a.additionalProps, id = _a.id;
    var product = items && items.length > 0 ? items[0] : undefined;
    return (react_1.default.createElement(index_1.Div, { id: id, key: (0, nanoid_1.nanoid)(), styles: (0, styles_1.removeNullValues)(styles) }, product &&
        currentComponentSchema.children &&
        currentComponentSchema.children.map(function (_a, index) {
            var productAttributeName = _a.id, type = _a.type, conditions = _a.conditions, customValue = _a.customValue, formatOptions = _a.formatOptions;
            var willBeRendered = (0, conditions_1.willComponentRender)(product, conditions, additionalProps);
            if (!willBeRendered) {
                return react_1.default.createElement(react_1.Fragment, { key: "none-".concat(index) });
            }
            // NOTE: pricer plaza products have nested product data support
            // and product properties are not validated
            var value = (0, values_1.getProductAttributeValue)({
                product: product,
                attributeName: productAttributeName,
                customValue: customValue,
                formatOptions: formatOptions
            });
            var imagePath = product.imagePath;
            if (type === seesignage_utils_1.ComponentType.div) {
                return (react_1.default.createElement(index_1.Div, { key: "".concat(productAttributeName, "-").concat(index), id: productAttributeName, styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, index, mediaKeys) }, value));
            }
            else if (type === seesignage_utils_1.ComponentType.text && value) {
                return (react_1.default.createElement(index_1.Text, { key: "".concat(productAttributeName, "-").concat(index), id: productAttributeName, styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, index), value: value || '', textfit: (0, styles_1.getTemplateChildrenTextFit)(templateChildren, index), textOptions: (0, styles_1.getTemplateChildrenTextOptions)(templateChildren, index) }));
            }
            else if (type === seesignage_utils_1.ComponentType.image && imagePath) {
                return (react_1.default.createElement(index_1.Image, { key: "".concat(productAttributeName, "-").concat(index), styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, index), src: imagePath, alt: 'image' }));
            }
            else if (type === seesignage_utils_1.ComponentType.qrCode && typeof value === 'string') {
                return (react_1.default.createElement(index_1.QrCode, { id: productAttributeName, key: "".concat(productAttributeName, "-").concat(index), styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, index), qrCodeOptions: __assign(__assign({}, (0, styles_1.getTemplateChildrenQrCodeOptions)(templateChildren, index)), { url: value }) }));
            }
            return react_1.default.createElement(react_1.Fragment, { key: "none-".concat(index) });
        })));
};
exports.default = ProductData;
//# sourceMappingURL=ProductData.js.map